import {getBootstrapData} from '@ui/bootstrap-data/bootstrap-data-store';
import {musicPreferenceOnboardingPath} from './requests';

export function userRequiresMusicPreferenceOnboarding(): boolean {
  const data = getBootstrapData();
  return !!(
    data.settings.player?.enable_music_preference_onboarding &&
    data.user?.music_preference_onboarding_required
  );
}

export function getMusicPreferenceRedirectUri(fallback = '/'): string {
  return userRequiresMusicPreferenceOnboarding()
    ? musicPreferenceOnboardingPath
    : fallback;
}
